<div class="wrap-dialog-content">
  <div class="d-flex align-items-center justify-content-between pb-3">
    <span class="dialog-title">{{data.title}}</span>
    <button type="button" mat-icon-button class="close-btn" (click)="onCanceled()">
      <mat-icon class="action-menu-icon">close</mat-icon>
    </button>
  </div>
  <div>
    <form [formGroup]="form">
      <div class="mb-2">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Name</mat-label>
          <input
            matInput
            formControlName="name"/>
          @if (form.controls.name.errors?.required) {
            <mat-error>Name is required</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="mb-2">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Alt Name</mat-label>
          <input
            matInput
            formControlName="altName"/>
          @if (form.controls.altName.errors?.required) {
            <mat-error>Alt name is required</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="mb-2">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Color</mat-label>
          <input
            matInput
            formControlName="color"/>
          @if (form.controls.color.errors?.required) {
            <mat-error>Color is required</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="mb-2">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Logo</mat-label>
          <input
            matInput
            formControlName="logo"/>
          @if (form.controls.logo.errors?.required) {
            <mat-error>Color is required</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="mb-2">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Background</mat-label>
          <input
            matInput
            formControlName="background"/>
          @if (form.controls.background.errors?.required) {
            <mat-error>Background is required</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="mb-2">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Packages</mat-label>
          <mat-select formControlName="packages" multiple>
            <mat-select-trigger>
              @if (form.controls.packages.value.length) {
                {{form.controls.packages.value.length === 1 ? '1 package selected' : form.controls.packages.value.length + ' packages selected'}}
              }
            </mat-select-trigger>
            @for (package of allPackages; track package) {
              <mat-option [value]="package">{{package}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="mb-2">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>One Time Enrollment Fee</mat-label>
          <input
            matInput
            appDecimalsOnly
            formControlName="oneTimeEnrollmentFee"/>
        </mat-form-field>
      </div>
    </form>
  </div>
  <div class="dialog-footer">
    <div mat-dialog-actions class="dialog-actions d-flex align-items-center justify-content-end p-0">
      <button mat-button color="primary" class="btn-sm" (click)="onCanceled()">Cancel</button>
      <button mat-raised-button class="btn-sm" color="primary" (click)="submit()">{{data.type === 'create' ? 'Create' : 'Edit'}}</button>
    </div>
  </div>
</div>
